<template>
  <div class="htmlBox">
    <div class="userinfo">
      <ul v-if="!isMobile">
        <li>
          <p>手机号</p>
          <input type="tel" placeholder="请输入手机号" v-model="phone" />
        </li>
        <li>
          <p>图片验证码</p>
          <input
            class="w200"
            type="num"
            placeholder="请输入图片验证码 "
            v-model="imgcode"
          />
          <img :src="codeImage" @click="getCaptcha" alt />
        </li>
        <li style="display: flex; width: 100%">
          <p>短信验证码</p>
          <input
            class="w200"
            type="num"
            name
            id
            value
            placeholder="请输入短信验证码 "
            v-model="code"
          />
          <em @click="getcode()" v-if="sign == false">发送验证码</em>
          <em v-else style="background: #bbbbbb; color: #fff"
            >{{ codehtml }}S</em
          >
        </li>
      </ul>

      <ul v-if="isMobile">
        <li>
          <p>账号</p>
          <input type="tel" placeholder="请输入账号" v-model="user_name" />
        </li>
        <li>
          <p>密码</p>
          <input type="password" placeholder="请输入密码" v-model="b2bpwd" />
        </li>
      </ul>
    </div>
    <button
      :disabled="btnState == false"
      :class="{ btnBg: btnState }"
      @click="sure()"
    >
      登录
    </button>

    <div class="checkLogin" @click="checkLogin" v-if="!isMobile && !onceCode">
      用户名密码登录
      <iconfont name="iconnavigate-right" size="0.5rem" color="#333"></iconfont>
    </div>

    <div v-if="isMobile">
      <button class="msgLogin" @click="checkMsgLogin">短信验证码登录</button>
      <div class="checkLogin">
        <p class="fr" @click="goPath('/resetPassword')">忘记密码</p>
        <p class="fl" @click="goPath('/register')">注册账号</p>
      </div>
    </div>

    <!--   切换登录方式   -->

    <div class="foot_box" v-show="hidshow">
      <div class="footer" @click="weixinFg" v-if="isWexinLogin && !onceCode">
        <div class="footer_tips">—— 微信登录 ——</div>
        <iconfont name="iconweixin4" size="1.5rem" color="#1FAD15"></iconfont>
      </div>
    </div>
  </div>
</template>

<script>
import Iconfont from "@/components/iconfont.vue";

import { sendRequest } from "@/assets/public";
import { Toast } from "vant";
import urlconfig from "@/config.js";

export default {
  components: { Iconfont },
  data() {
    return {
      phone: "", //手机号
      code: "", //验证码
      sign: false, //是否点击获取验证码按钮
      time: "", //倒计时
      isClick: false,
      codehtml: "",
      isMobile: false, //是否是手机号验证码登录
      onceCode: "", // 唯一code
      imgcode: "",
      codeImage: null, // 图形验证码
      imgKey: "", // 图片验证码的key
      isCodeTimes: true,

      user_name: "", // 账号
      b2bpwd: "", // 密码

      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hidshow: true, //显示或者隐藏footer
    };
  },
  created() {
    this.getCaptcha();
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight;
      })();
    };
  },
  mounted() {
    let search = window.location.href.split("?")[1]
      ? window.location.href.split("?")[1].split("code=")[1]
      : "";
    if (search) {
      this.getOpenid(search.indexOf("&") > -1 ? search.split("&")[0] : search);
    } else {
      this.onceCode = "";
    }
  },

  methods: {
    // 协议
    protocolFg() {
      this.isProtocol = !this.isProtocol;
    },
    async getCaptcha() {
      if (!this.isCodeTimes) {
        return;
      }
      this.isCodeTimes = false;
      console.log("----------------");
      let res = await sendRequest("user/getCaptcha", {});
      if (res.status == 200) {
        this.codeImage = res.content.img;
        this.imgKey = res.content.key;
        setTimeout(() => {
          this.isCodeTimes = true;
        }, 500);
      }
    },
    goPath(url) {
      this.$router.push(url);
    },
    getOpenid(key) {
      this.onceCode = key;
    },
    // 微信授权
    weixinFg() {
      var appid = "wxcef271c70c3c8428"; // appid
      var url = window.encodeURIComponent(`${urlconfig.goPath}login`); // 回调链接地址，需转码为URI格式，必须去除#后的参数
      var scope = "snsapi_userinfo"; // snsapi_base静默授权，snsapi_userinfo弹出授权页面
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`;
    },

    checkLogin() {
      console.log(132);
      this.isMobile = true;
    },
    checkMsgLogin() {
      this.isMobile = false;
    },

    // 获取验证码  code与无code
    async getcode() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast("手机号码有误");
        return false;
      } else {
        let path = "user/sendNoCodeSms";

        if (this.imgcode == "") {
          Toast("请输入图形验证码");
          return;
        }
        console.log(this.imgKey);
        let params = {
          phone_mob: this.phone,
          captcha_code: this.imgcode,
          key: this.imgKey,
          code: this.onceCode,
        };
        let res = await sendRequest(path, params);
        console.log(res);
        if (res.status == 200) {
          this.codehtml = 60;
          this.sign = true;
          let tim = setInterval(() => {
            this.codehtml = this.codehtml - 1;
            if (this.codehtml <= 0) {
              clearInterval(tim);
              this.sign = false;
              return false;
            }
          }, 1000);
          this.time = tim;
        } else {
          Toast(res.msg);
        }
      }
    },
    //登录
    async sure() {
      if (this.onceCode) {
        // 存在code的登录
        this.codeLogin();
      } else {
        // 手机号或者账号直接登录
        if (!this.isMobile) {
          this.lateralLoginFg();
        } else {
          this.acctionFg();
        }
      }
    },
    // 无code手机号验证码登录
    async lateralLoginFg() {
      if (this.isClick == false) {
        let tips = null;
        if (this.phone == "") {
          tips = "请输入手机号";
        } else if (this.code == "") {
          tips = "请输入短信验证码";
        } else if (this.imgcode == "") {
          tips = "请输入图片验证码";
        }
        if (tips) {
          Toast(tips);
          return;
        }
        let res = await sendRequest("user/loginOfficial", {
          phone_mob: this.phone,
          sms_code: this.code,
        });
        if (res.status != 200) {
          Toast(res.msg);
          this.isClick = false;
        } else {
          this.isClick = true;
          Toast("登录成功");
          localStorage.setItem("token", res.content.token);
          localStorage.setItem("infor", JSON.stringify(res.content));
          setTimeout(() => {
            this.$router.push({ path: "/personalCenter" });
          }, 2000);
        }
      }
    },
    // 无code账号密码登录
    async acctionFg() {
      if (this.user_name == "") {
        Toast("请输入账号");
      } else if (this.b2bpwd == "") {
        Toast("请输入密码");
      } else {
        let res = await sendRequest("user/loginMembers", {
          user_name: this.user_name,
          b2bpwd: this.b2bpwd,
        });
        if (res.status != 200) {
          Toast(res.msg);
          if (res.status == "2364") {
            this.$router.push({
              path: `/bindphone?user_name=${this.user_name}&b2bpwd=${this.b2bpwd}`,
            });
          }
        } else {
          Toast("登录成功");
          localStorage.setItem("token", res.content.token);
          localStorage.setItem("infor", JSON.stringify(res.content));
          setTimeout(() => {
            this.$router.push({ path: "/personalCenter" });
          }, 2000);
        }
      }
    },
    // 有code
    async codeLogin() {
      if (this.isClick == false) {
        if (this.phone == "") {
          Toast("请输入手机号");
          this.isClick = false;
        } else if (this.code == "") {
          Toast("请输入验证码");
          this.isClick = false;
        } else {
          let res = await sendRequest("user/bindPhone", {
            phone_mob: this.phone,
            sms_code: this.code,
            code: this.onceCode,
          });
          if (
            res.status == "400" &&
            res.msg == "Undefined index: access_token"
          ) {
            Toast("授权失效，请重新授权登录");
            this.isClick = true;

            setTimeout(() => {
              var appid = "wxcef271c70c3c8428"; // appid
              var url = window.encodeURIComponent(`${urlconfig.goPath}login`); // 回调链接地址，需转码为URI格式，必须去除#后的参数
              var scope = "snsapi_userinfo"; // snsapi_base静默授权，snsapi_userinfo弹出授权页面
              window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`;
            }, 1500);
          } else if (res.status != 200) {
            Toast(res.msg);
            this.isClick = false;
          } else {
            this.isClick = true;
            Toast("登录成功");
            localStorage.setItem("token", res.content.token);
            localStorage.setItem("infor", JSON.stringify(res.content));
            setTimeout(() => {
              this.$router.push({ path: "/personalCenter" });
            }, 2000);
          }
        }
      }
    },
  },
  computed: {
    btnState() {
      //当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      return this.isMobile
        ? this.user_name !== "" && this.b2bpwd !== ""
        : this.phone !== "" && this.code !== "";
    },
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.hidshow = false;
      } else {
        this.hidshow = true;
      }
    },
  },
};
</script>
<style scoped>
.msgLogin {
  width: 13.6rem;
  height: 2rem;
  line-height: 2rem;
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 50px;
  background: #fff;
  color: #333;
  font-size: 0.6rem;
}

/* ------ 底部 ------ */
.foot_box {
  width: 100vw;
  position: fixed;
  bottom: 0.5rem;
  left: 0;
}

.footer {
  width: 15rem;
  text-align: center;
}

.footer_tips {
  text-align: center;
  font-size: 0.48rem;
  color: rgba(153, 153, 153, 1);
  margin-bottom: 0.4rem;
}

.xieyi {
  margin-top: 0.5rem;
  width: 100%;
  font-size: 0.46rem;
  text-align: center;
  color: rgba(51, 51, 51, 1);
}

.xieyi .iconfont {
  margin-right: 0.3rem;
}

.xieyi b {
  color: #fd3e3e;
}

/* ------ end 底部 ------ */

.checkLogin {
  color: #333333;
  font-size: 0.48rem;
  width: 13.6rem;
  margin-left: 0.7rem;
  text-align: center;
  line-height: 2rem;
  color: #fd3e3e;
}

/*button禁用时的背景颜色*/
button {
  width: 13.6rem;
  height: 2rem;
  background: rgba(221, 221, 221, 1);
  border-radius: 50px;
  margin-left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  margin-top: 0.8rem;
  color: #fff;
  border: none;
}

/*button可用时的背景颜色*/
.btnBg {
  width: 13.6rem;
  height: 2rem;
  border-radius: 50px;
  margin-left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  color: #fff;
  background: #fd3e3e;
  margin-top: 0.8rem;
  border: none;
}

.htmlBox {
  min-height: 100%;
  display: block;
  background: #fff
    url("https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/loin_img.png")
    no-repeat center top;
  background-size: 15rem 6.54rem;
  width: 100%;
  overflow: hidden;
}

.userinfo {
  width: 100vw;
  padding-top: 8rem;
  overflow: hidden;
}

.userinfo ul {
  padding: 0 0.8rem;
}

.userinfo ul li {
  height: 1.6rem;
  line-height: 1.6rem;
  border-bottom: 1px solid #eee;
  padding-top: 0.4rem;
}

.userinfo ul li:last-child {
  border-bottom: none;
}

.userinfo ul li p {
  float: left;
  font-size: 0.56rem;
  color: #333333;
  width: 3rem;
}

.userinfo ul li input {
  width: 8rem;
  float: left;
  border: none;
  font-size: 0.56rem;
  padding-left: 0.4rem;
  background: none;
}

.userinfo ul li img {
  display: block;
  width: 3.6rem;
  height: 1.4rem;
  float: right;
}

.userinfo ul li input.w200 {
  width: 6rem !important;
}

.userinfo ul li em {
  width: 3.6rem;
  height: 1.4rem;
  background: #fd3e3e;
  border-radius: 0.2rem;
  color: #fff;
  line-height: 1.4rem;
  float: right;
  font-size: 0.56rem;
  font-style: normal;
  text-align: center;
}

.sure_btn {
  width: 13.6rem;
  height: 2rem;
  background: rgba(221, 221, 221, 1);
  border-radius: 0.2rem;
  position: absolute;
  bottom: 1.6rem;
  left: 0.7rem;
  line-height: 2rem;
  font-size: 0.6rem;
  color: #fff;
}

.active {
  background: #fd3e3e !important;
}
</style>